// const log = require('debug')('app:containers:root-prod')
import React, { Component } from 'react'
import Routing from '../routing'
import {Provider} from 'react-redux'
import store from './store'

class Root extends Component {
  render () {
    return (
      <Provider store={store}>
        <div>
          <Routing />
        </div>
      </Provider>
    )
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/containers/root/root.prod.js